/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'

import Menu from '../../../components/Menu'

import 'react-modern-calendar-datepicker/lib/DatePicker.css'
import DatePicker from '@taak/react-modern-calendar-datepicker'

import { useForm } from "react-hook-form"
import { post } from '../../../services/http'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { useNavigate } from 'react-router-dom'

export default function index() {
  const navigate = useNavigate()
  const [selectedDay, setSelectedDay] = useState('')

  const { register, handleSubmit } = useForm()

  const token = localStorage.getItem('token')

  const onSubmit = (data, e) => {
    e.preventDefault()

    if (selectedDay !== '') {
      post(`/api/admin/offcode/create?token=${token}`, {
        code: data.code,
        percent: data.percent,
        enDate: selectedDay
      }).then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/offs')
        }, 2000)
      }).catch(error => {
        if (error.response.data.messageFa === "این کد تخفیف موجود می باشد") {
          return notify('error', 'کد تخفیف موجود می باشد')
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
    }
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'offcode'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                ایجاد کد تخفیف
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ایجاد کد تخفیف لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات کد تخفیف‌
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeName'>نام کد تخفیف * :</label>
                <input id='offCodeName' {...register("code", { required: true, minLength: 3 })} className='ltrdirection' type='text' placeholder='start' />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='offCodePercent'>درصد کد تخفیف * :</label>
                <input id='offCodePercent' {...register("percent", { required: true, minLength: 1 })}  className='ltrdirection' type='text' placeholder='25' />
                <small id='offCodePercentAlert'>درصد کد تخفیف باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeDate'>تاریخ اتمام * :</label>
                <small id='offCodeDateAlert'>اولویت باید وارد شود</small>
                <DatePicker
                  value={selectedDay}
                  onChange={setSelectedDay}
                  shouldHighlightWeekends
                  locale="fa" // add this
                />
              </div>
            </div>
            <button className='createButton'>ایجاد کد تخفیف</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
